import { render, staticRenderFns } from "./AllocationChart.vue?vue&type=template&id=62fcd4ca&scoped=true"
import script from "./AllocationChart.vue?vue&type=script&setup=true&lang=ts"
export * from "./AllocationChart.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./AllocationChart.vue?vue&type=style&index=0&id=62fcd4ca&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "62fcd4ca",
  null
  
)

export default component.exports